/**
 * Durum rozeti: durumdan metin + şekil + ton üretir (şartname 3 ve 7). Renk tek başına işaret değildir: her durumun
 * kendi şekli ve metni var. Taslağın `.okb/.nob/.st/.warnbadge` sınıfları uygulanmadı; tek bileşen.
 */
import { HIZLI_METIN as M } from '../metin/hizliTeklif';
import { DURUM_BILGISI } from './mantik';
import { Ikon } from './Ikon';
import type { DurumKodu } from './tipler';

export function DurumRozeti({ kod, metin, yeni = false, odaNo = null }: { kod: DurumKodu; metin?: string; yeni?: boolean; odaNo?: number | null }) {
  const b = DURUM_BILGISI[kod];
  const yazi = metin ?? (kod === 'uymuyor' && odaNo !== null ? M.odaUymuyor(odaNo) : M.durum[kod]);
  return (
    <span className="ht-durum-kap">
      <span className={`ht-durum ht-ton-${b.ton}`} data-durum={kod}>
        <Sekil sekil={b.sekil} />
        <span>{yazi}</span>
      </span>
      {yeni ? <span className="ht-yeni">{M.yeniGeldi}</span> : null}
    </span>
  );
}

function Sekil({ sekil }: { sekil: (typeof DURUM_BILGISI)[DurumKodu]['sekil'] }) {
  if (sekil === 'ucgen') return <Ikon ad="uyari" kucuk />;
  if (sekil === 'carpi') return <Ikon ad="kapat" kucuk />;
  return <span className={`ht-sekil ht-sekil-${sekil}`} aria-hidden="true" />;
}
